module.exports = __webpack_public_path__ + "static/award-rating-6a9a45debb26e001bb1c4d376030efbe.png";